import Audiotrack from '@mui/icons-material/Audiotrack';
import Image from '@mui/icons-material/Image';
import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import Videocam from '@mui/icons-material/Videocam';
import type { SxProps, Theme } from '@mui/material';
import type React from 'react';

import { AUDIO, IMAGE, MXF, PDF, VIDEO } from 'src/constants';

const DEFAULT_SX: SxProps<Theme> = { fontSize: 14 };

/**
 * Map an asset's mediatype string to a Material UI icon element.
 *
 * Uses `.includes()` matching consistent with `determineMediaType` in `src/helpers.ts`.
 * Returns a fallback file icon when the mediatype is unknown or absent.
 */
export function getMediaTypeIcon(mediatype?: string | null, sx?: SxProps<Theme>): React.ReactElement {
  const iconSx = sx ?? DEFAULT_SX;

  if (mediatype) {
    if (mediatype.includes(VIDEO) || mediatype.includes(MXF)) {
      return <Videocam sx={iconSx} />;
    }
    if (mediatype.includes(AUDIO)) {
      return <Audiotrack sx={iconSx} />;
    }
    if (mediatype.includes(IMAGE)) {
      return <Image sx={iconSx} />;
    }
    if (mediatype.includes(PDF)) {
      return <PictureAsPdf sx={iconSx} />;
    }
  }

  return <InsertDriveFile sx={iconSx} />;
}
